export default __webpack_public_path__ + "static/media/algon-logo.24d78832.png";